import React, { useRef, useEffect, ReactNode } from 'react';

interface OutsideClickHandlerProps {
  children: ReactNode;
  exceptionRef?: React.RefObject<HTMLElement | null>;
  onClick: () => void;
  className?: string;
}

const OutsideClickHandler: React.FC<OutsideClickHandlerProps> = ({
  children,
  exceptionRef,
  onClick,
  className = '',
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickListener = (event: MouseEvent) => {
      const target = event.target as Node;
      const clickedInside = wrapperRef.current?.contains(target) || exceptionRef?.current?.contains(target) || false;

      if (!clickedInside) {
        onClick();
      }
    };

    document.addEventListener('click', handleClickListener);

    return () => {
      document.removeEventListener('click', handleClickListener);
    };
  }, [exceptionRef, onClick]);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default OutsideClickHandler;
